import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CFormSelect,
  CFormCheck,
} from "@coreui/react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import { createReport } from "../../services/report.services";
import { uploadImage } from "src/services/util.services";
import ReactSelect from "react-select";
import { getActiveCountryList } from "src/services/country.services";

const schema = z.object({
  title: z.string().min(1, "Please type a title"),
  description: z.string().min(1, "Please type a description"),
  image: z.string().optional(),
  country: z.string().min(1, "Please select country"),
});

const ReportIssueForm = () => {
  const [userInfo, setUserInfo] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const inputFileRef = useRef(null);
  const [userId, setUserId] = useState("");
  const [userData, setUserData] = useState(null);
  const [allUserTypeData, setAllUserTypeData] = useState(null);
  const [userTypeData, setUserTypeData] = useState(null);
  const [userImage, setUserImage] = useState(null);
  const [selecteduserType, setSelecteduserType] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const defaultErrorMessage = "Something went wrong";
  useEffect(() => {
    if (userInfo?.country) {
      setValue("country", userInfo.country._id);
      setSelectedCountry({
        value: userInfo.country._id,
        label: userInfo.country.name,
      });
    }

    if (userInfo?.userType === "superAdmin") {
      getActiveCountries();
    }
  }, []);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      description: "",
      image: "",
      country: selectedCountry ? selectedCountry.value : "",
    },
    resolver: zodResolver(schema),
  });

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleReset = () => {
    setValue("title", "");
    setValue("description", "");
    setValue("image", "");
    inputFileRef.current.value = "";
    if (userInfo?.userType === "superAdmin") {
      setValue("country", "");
      setSelectedCountry("");
    }
  };

  const onSubmit = (data) => {
    console.log(data);
    toast
      .promise(
        createReport(data),
        {
          loading: "Loading",
          success: "Report Created Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "create-report",
        }
      )
      .then(async (response) => {
        handleReset();
        setUserImage(null);
      })
      .catch((error) => console.error(error));
  };

  const onError = (err) => {
    console.error(err);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    toast
      .promise(
        uploadImage(formData, config),
        {
          loading: "Loading",
          success: "Image added Succesfully",
          error: (err) => {
            console.log(err);
            return "Something went wrong. Please upload again";
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        setValue("image", response.url);
        setUserImage(response.url);
      })
      .catch((error) => console.error(error));
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
      setValue("country", selectedOption.value);
    } else {
      setSelectedCountry(null);
      setValue("country", "");
    }
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
              Create Issue
            </h4>
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel htmlFor="title" className="col-sm-3 col-form-label">
                  Title
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput type="text" id="title" {...register("title")} />
                  {errors.title?.message && (
                    <p className="error_text">{errors.title?.message}</p>
                  )}
                </CCol>
              </CRow>

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="description"
                  className="col-sm-3 col-form-label"
                >
                  Description:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormTextarea
                    id="description"
                    rows={3}
                    {...register("description")}
                    // text="Must be 8-20 words long."
                  ></CFormTextarea>
                  {errors.description?.message && (
                    <p className="error_text">{errors.description?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="firstName"
                  className="col-sm-3 col-form-label"
                >
                  Country:
                </CFormLabel>
                <CCol sm={8}>
                  <ReactSelect
                    value={selectedCountry}
                    options={countrySelectOptions}
                    onChange={handleCountryChange}
                    isClearable={true}
                    placeholder="Select Country"
                    isDisabled={
                      userInfo.userType === "superAdmin" ? false : true
                    }
                  />
                  {errors.country?.message && (
                    <p className="error_text">{errors.country?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel htmlFor="image" className="col-sm-3 col-form-label">
                  Image:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    ref={inputFileRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                  />
                  {errors.image?.message && (
                    <p className="error_text">{errors.image?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={12}>
                  <img src={userImage} height={110} />
                </CCol>
              </CRow>
            </CCol>

            <div className="d-flex justify-content-end mt-3">
              <CButton type="submit" color="primary" className="px-5 py-2">
                Submit
              </CButton>
            </div>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default ReportIssueForm;
